import ObjectHelper from 'foundation/object-helper';
import ValidationHelper from '../../../general/js/basket/validation-helper';
import { hasValue } from '../../../general/js/general-helpers';

function getLatestAddedTickets(basketGroups, selectedGroups) {
    const latestAddedTickets = [];
    selectedGroups.forEach((element) => {
        const item = element;
        const itemId = item.id;
        const basketElement = basketGroups[itemId];

        if (basketElement === undefined) {
            latestAddedTickets.push(element);
        }
    });

    return latestAddedTickets;
}

function getTicketItemBasedOnQueryParam(selectedGroups) {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const ticketId = params.get('g');

    if (ticketId !== null) {
        const foundTicket = selectedGroups.find(({ id }) => id.toLowerCase() === ticketId.toLowerCase());
        if (hasValue(foundTicket))
        {
            return foundTicket;
        }
    }

    return selectedGroups[0];
}

export default class ProductsHelper {
    static getProductsList(selectedGroups, basketGroups, filterFunction) {
        if (selectedGroups.length === 0) {
            return [];
        }
        const latestAddedTickets = getLatestAddedTickets(basketGroups, selectedGroups);

        const firstSelectedProductGroup = latestAddedTickets[0] !== undefined ?
            latestAddedTickets[0] :
            getTicketItemBasedOnQueryParam(selectedGroups);

        if (!firstSelectedProductGroup.products) return [];

        const productList = ObjectHelper.clone(firstSelectedProductGroup.products.filter((product) =>
            filterFunction(product)));

        productList.forEach((product) => {
            // set quantity from basket product group
            product.quantity = 0;

            if (firstSelectedProductGroup.id in basketGroups) {
                const basketProductGroup = basketGroups[firstSelectedProductGroup.id];
                basketProductGroup.products.forEach((basketProduct) => {
                    if (basketProduct.type === product.type &&
                        basketProduct.tag === product.tag
                    ) {
                        product.quantity = basketProduct.quantity;
                    }
                });
            }
        });

        return ValidationHelper.getPreparedProductsList(productList);
    }

    static getStandaloneProductsList(selectedGroups, basketGroups, filterFunction) {
        if (selectedGroups.length === 0) {
            return [];
        }

        var productList = [];
        var i = 0;

        selectedGroups.forEach((selectedGroup) => {
            const productListSelectedGroup = ObjectHelper.clone(selectedGroup.products.filter((product) =>
            filterFunction(product)));

            productListSelectedGroup.forEach((product) => {
                // set quantity from basket product group
                product.quantity = 0;
                if (selectedGroup.id in basketGroups) {
                    const basketProductGroup = basketGroups[selectedGroup.id];
                    basketProductGroup.products.forEach((basketProduct) => {
             
                      
                        if (basketProduct.type === product.type &&
                            basketProduct.tag === product.tag
                        ) {
                           
                            product.quantity = basketProduct.quantity;
                        }
                    });
                }
                
                productList[i] = product;
                i++;
            });
        });

        return ValidationHelper.getPreparedProductsList(productList);
    }

    // eslint-disable-next-line consistent-return

}
